import typography from './typography';
import sizes, { smallSizes } from './sizes';
import colors from './colors';
import { createTheme } from '@mui/material/styles';
//import { enUS } from '@material-ui/core/locale';

const breakpoints = ['600px', '1024px', '1360px', '1440px'];

const theme = {
  ...typography,
  sizes,
  space: smallSizes,
  colors,
  breakpoints,
  //enUS,
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary || '#1976d2',
    },
    secondary: {
      main: colors.secondary || '#dc004e',
    },
    background: {
      default: colors.white || '#fafafa',
      paper: colors.white || '#ffffff',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white || '#ffffff',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white || '#ffffff',
          color: colors.black || '#000000',
        },
      },
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
    body1: {
      fontSize: '14px',
    },
    body2: {
      fontSize: '14px',
    },
  },
});

export * from './utils';
export default theme;

